import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';

// Components 

import Box from '@mui/material/Box';
import Button from '../../../general/inputs/Button';
import { updateConsultation } from '../../../../routes/doctor/consultation';
import { setIsConsent, setIsConsentPopupOpened } from '../../../../redux/features/doctor/Dashboard/consultation/consultation';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { setNotificationMessage } from '../../../../redux/features/general/notification';
import CancelButton from '../../../general/inputs/CancelButton';


interface Props { 

}; 

const Consent: React.FC<Props> = ({ }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 
    const isMobile = useMediaQuery('(max-width: 768px)');

    const { consultationId } = useParams(); 

    const colors = useAppSelector(state => state.theme.colors); 

    // -- 

    const handleConsent = async () => { 

        const content = { 
            consultationId: consultationId,
            isConsentGiven: true
        }; 

        updateConsultation(content); 

        dispatch(setIsConsent(true)); 

        dispatch(setNotificationMessage(t('patientConsentEnabled'))); 

        dispatch(setIsConsentPopupOpened(false)); 

    }; 

    // -- 

    const handleQuit = () => { 

        dispatch(setIsConsentPopupOpened(false)); 

    }; 
    
    // -- 

    return (

        <Box 
            onClick={handleQuit}
            sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'center',
                width: '100vw',
                height: '100vh', 
                backgroundColor: colors?.popup, 
                overflow: 'hidden', 
                position: 'absolute', 
                zIndex: 100000000,
        }}>

            <Box
                onClick={(e) => e.stopPropagation()}
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    alignItems: 'center', 
                    justifyContent: 'space-evenly',
                    textAlign: 'center', 
                    width: '100%',
                    maxWidth: isMobile ? '90vw' : '400px', 
                    padding: isMobile ? 2 : 3, 
                    borderRadius: isMobile ? 4 : 5,
                    fontSize: 14,
                    backgroundColor: colors?.container,
                }}
            >

                <Box
                    component="img"
                    sx={{
                        width: isMobile ? 80 : 100,
                        marginTop: 2, 
                        marginBottom: 2, 
                    }}
                    src={require('../../../../assets/icons/consultation/patientConsent.png')}
                />

                <Box
                    sx={{ 
                        width: '90%',
                        marginBottom: 3 
                    }}
                >{t('recordingConsent')}

                </Box>

                <Button 
                    title={'agree'}
                    triggerFunction={handleConsent}
                    extraStyle={{ width: '80%', marginBottom: 2 }}
                />

            </Box>

            <CancelButton handler={handleQuit} />

        </Box>

  );

};

export default Consent;